import { RncpDto, RncpFiltersDto, RncpProjection } from '../rncp';
import { buildPageableParams, PageableArgs } from '../common';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { servicesApi } from '../services';

const RNCPS_URL_PREFIX = 'rncps';

const rncpApi = servicesApi.injectEndpoints!({
    endpoints: (build) => ({

        getRncps: build.query<RncpDto[], GetRncpsQueryArgs, any>({
            queryFn: (args, _api, _extraOptions, baseQuery) => queryUntilLastPage({
                baseQuery,
                url: RNCPS_URL_PREFIX,
                params: buildPageableParams(args),
            }),
        }),

    }),
});

interface GetRncpsQueryArgs extends PageableArgs<RncpProjection> {
    filtres: RncpFiltersDto;
}

export const {
    useLazyGetRncpsQuery,
} = rncpApi;